import type { FaqSection } from "./types";

const customerPortalFeatures = [
  { description: "Track your project’s progress step by step" },
  { description: "Access and sign all documents in one place" },
  { description: "Communicate easily with your solar company" },
  { description: "See reviews and examples of past projects completed by your installer" },
];

const projectSafeguards = [
  { title: "Title Checks", description: "To confirm your property details are correct before the project begins" },
  {
    title: "Smart Pulls",
    description: "A soft credit check that matches you with the financing options you’re most likely to qualify for",
  },
  { title: "Savings Calculator", description: "Clear estimates of your potential energy savings" },
  {
    title: "Battery Sizing Tool",
    description: "Proper system and storage sizing to ensure your solar + storage solution fits your needs",
  },
];

const homeownersSection: FaqSection = {
  id: "homeowners-enerflo",
  title: "Homeowners Working with Solar Companies Powered by Enerflo",
  faqs: [
    {
      question: "How does Enerflo benefit me as a homeowner going solar?",
      answer: (
        <>
          <p>
            If your solar installer uses Enerflo, you’ll enjoy a smoother, more transparent solar experience. Enerflo
            powers a <strong>personalized Customer Portal</strong> just for you, where you can:
          </p>
          <br />
          <ul className="list-disc space-y-1 ml-4">
            {customerPortalFeatures.map(item => (
              <li key={item.description}>{item.description}</li>
            ))}
          </ul>
          <br />
          <p>This gives you peace of mind knowing everything is centralized, secure, and accessible.</p>
        </>
      ),
    },
    {
      question: "What safeguards does Enerflo provide to make sure my solar project is set up correctly?",
      answer: (
        <>
          <p>
            Enerflo helps your solar company get things right from the start with tools that protect you and your
            investment:
          </p>
          <br />
          <ul className="list-disc space-y-1 ml-4">
            {projectSafeguards.map(item => (
              <li key={item.title}>
                <strong>{item.title}</strong> – {item.description}
              </li>
            ))}
          </ul>
          <br />
          <p>These upfront safeguards help prevent costly errors, delays, and surprises later in the process.</p>
        </>
      ),
    },
    {
      question: "How does Enerflo help keep my solar project on track?",
      answer: (
        <p>
          Enerflo automates key steps in the solar installation process to reduce delays and keep everything moving
          forward. With real-time updates in your Customer Portal and streamlined communications, you’ll always know
          where your project stands. This efficiency builds <strong>trust and confidence</strong> that your solar
          installer is delivering on time and with transparency.
        </p>
      ),
    },
  ],
};

export default homeownersSection;
